window.Honeybadger = require('honeybadger-js')
